import { render, staticRenderFns } from "./ClientGeneral.vue?vue&type=template&id=73666409&scoped=true"
import script from "./ClientGeneral.vue?vue&type=script&lang=ts"
export * from "./ClientGeneral.vue?vue&type=script&lang=ts"
import style0 from "./ClientGeneral.vue?vue&type=style&index=0&id=73666409&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73666409",
  null
  
)

export default component.exports